import { render } from "./CreateBoardDialog.vue?vue&type=template&id=58a0e6e6"
import script from "./CreateBoardDialog.vue?vue&type=script&lang=js"
export * from "./CreateBoardDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__